import type { Gender } from '../api/types';
import { mascotImagePath, type Tradition } from '../theme/tokens';

interface GenderPickerProps {
  selected: Gender | null;
  onChange: (gender: Gender) => void;
  /** When known, preview the guide in the outfit for this tradition instead of the generic one. */
  tradition?: Tradition | null;
}

const OPTIONS: { value: Gender; label: string }[] = [
  { value: 'female', label: 'Female guide' },
  { value: 'male', label: 'Male guide' },
];

/** Lets the user pick which standing mascot illustration greets them -- purely cosmetic,
 * never affects content filtering. Previews the actual costumed outfit for `tradition` when
 * one is already known, so picking a practice visibly changes the guide's appearance. */
export function GenderPicker({ selected, onChange, tradition }: GenderPickerProps) {
  return (
    <div className="gender-grid">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`gender-card${selected === opt.value ? ' selected' : ''}`}
          onClick={() => onChange(opt.value)}
          aria-pressed={selected === opt.value}
        >
          <img src={mascotImagePath(tradition, opt.value)} alt="" className="gender-card-image" />
          <span className="gender-card-label">{opt.label}</span>
        </button>
      ))}
    </div>
  );
}
